import React, { useState } from 'react';
import TimePicker from './TimePicker';
import { formatTimeDisplay } from '../utils/timeFormatting';

interface TimeInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (name: string, formattedValue: string) => void;
  disabled?: boolean;
}

const TimeInput: React.FC<TimeInputProps> = ({ label, name, value, onChange, disabled }) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleTimeChange = (newValue: string) => {
    onChange(name, newValue);
    setShowPicker(false);
  };

  const handleClear = () => {
    onChange(name, '');
  };

  const displayValue = formatTimeDisplay(value);

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}:</label>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => !disabled && setShowPicker(true)}
          className={`flex-1 min-h-[44px] px-4 py-2 text-left border rounded-lg shadow-sm ${
            disabled 
              ? 'bg-gray-100 cursor-not-allowed' 
              : 'bg-white hover:bg-gray-50 focus:ring-2 focus:ring-blue-500'
          } ${!displayValue ? 'text-gray-500' : 'text-gray-900'}`}
          disabled={disabled}
        >
          {displayValue || 'Select time'}
        </button>
        {value && !disabled && (
          <button
            type="button"
            onClick={handleClear}
            className="w-11 h-11 flex items-center justify-center text-gray-500 hover:text-red-500 focus:outline-none"
            title="Clear time"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>

      {showPicker && (
        <TimePicker
          value={value}
          onChange={handleTimeChange}
          onClose={() => setShowPicker(false)}
        />
      )}
    </div>
  );
};

export default TimeInput;